import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BORDER_GRAY } from 'constants/colors';
export default makeStyles(theme => createStyles({
  agreementsRoot: {
    display: 'flex',
    flexFlow: 'column wrap',
    margin: '0 auto',
    paddingTop: 0
  },
  agreementInfoBox: {
    border: `1px solid ${BORDER_GRAY}`,
    padding: theme.spacing(1)
  },
  vehicleCardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  balanceInfoBody: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center'
  },
  balanceInfoHelper: {
    display: 'flex'
  },
  tooltipText: {
    fontSize: '1em'
  },
  changeName: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
    '& > *': {
      color: 'inherit'
    }
  },
  spacingRight: {
    marginRight: theme.spacing(2)
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  sectionGetStarted: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    margin: theme.spacing(4, 0, 2, 0)
  },
  sectionIcon: {
    marginRight: theme.spacing(1.5)
  },
  sectionIconRight: {
    marginLeft: theme.spacing(1.5)
  },
  sectionLinkWithSpacing: {
    margin: theme.spacing(0.5, 0, 2)
  },
  editName: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2)
    }
  },
  agreementAddressTitle: {
    maxWidth: `calc(50% - 16px)`,
    marginRight: theme.spacing(2)
  },
  listItem: {
    margin: theme.spacing(1, 0),
    listStyle: 'none',
    display: 'flex',
    textAlign: 'left',
    wordBreak: 'break-all',
    '& > div': {
      width: '50%'
    }
  },
  // AgreementInfo
  addressCol: {
    flex: 1
  },
  addressInfo: {
    fontWeight: 'normal',
    display: 'block'
  },
  vehicleButtons: {
    minWidth: '220px',
    textAlign: 'left',
    marginBottom: theme.spacing(1),
    '& > .MuiButton-label': {
      justifyContent: 'flex-start'
    }
  }
}));